import { render, staticRenderFns } from "./TemplateAction.vue?vue&type=template&id=45dae89d&scoped=true&"
import script from "./TemplateAction.vue?vue&type=script&lang=js&"
export * from "./TemplateAction.vue?vue&type=script&lang=js&"
import style0 from "./TemplateAction.vue?vue&type=style&index=0&lang=css&"
import style1 from "./TemplateAction.vue?vue&type=style&index=1&id=45dae89d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45dae89d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VChip,VIcon,VList,VListItem,VListItemSubtitle,VMenu})
